module.exports = __webpack_public_path__ + "static/leaf-1-ddaef903b8105e0e3a0e8325427ce71a.png";